"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M7.222 22c-.56 0-1.04-.2-1.44-.599a1.96 1.96 0 0 1-.598-1.439V5.856c0-.56.2-1.04.598-1.439.4-.4.88-.599 1.44-.599h2.092c.186-.533.529-.97 1.03-1.309.5-.34 1.046-.509 1.64-.509.615 0 1.17.17 1.666.51a2.63 2.63 0 0 1 1.027 1.308h2.102c.56 0 1.04.2 1.439.599.399.4.598.879.598 1.44v14.105c0 .56-.2 1.04-.598 1.44-.4.398-.88.598-1.44.598H7.223Zm0-2.038h9.556V5.856h-.962V7.61a.984.984 0 0 1-.295.724.984.984 0 0 1-.724.295H9.175a.984.984 0 0 1-.724-.295.984.984 0 0 1-.295-.724V5.856h-.934v14.106Zm4.762-14.186a.867.867 0 0 0 .639-.258.867.867 0 0 0 .257-.638.867.867 0 0 0-.257-.638.867.867 0 0 0-.639-.258.867.867 0 0 0-.638.258.867.867 0 0 0-.258.638c0 .254.086.467.258.638a.867.867 0 0 0 .638.258Z"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};